import type { DeviceMediaItem } from "@workspace/api-client-react";
import { IMAGE_DEFAULT_DISPLAY_SEC } from "@workspace/player-core";

/** Default on-screen duration for still images without a configured length. */
export const DEFAULT_IMAGE_DISPLAY_SEC = IMAGE_DEFAULT_DISPLAY_SEC;

/**
 * Resolve how long a still image should remain on the visual surface.
 * Schedule-item override wins, then the media metadata, then the shared
 * default — the same precedence the server loader applies, so preview,
 * plan durations, and on-device display agree.
 */
export function imageDisplaySeconds(
  item: DeviceMediaItem,
  configuredSec?: number | null,
  fallback = DEFAULT_IMAGE_DISPLAY_SEC,
): number {
  if (configuredSec != null && configuredSec > 0) return configuredSec;
  if (item.durationSec != null && item.durationSec > 0) return item.durationSec;
  return fallback;
}
